// extracted by mini-css-extract-plugin
export default {"price":"Ula-z","onSale":"Vla-z","msrpLabelPrice":"Wla-z","msrpLabel":"Xla-z","originalPrice":"Yla-z"};